import React from 'react';
import { TitleAddition } from '@pixelogicmedia/phelix_coredb_frontend';
import { getEnv, interceptor, creationSource } from "../../helpers/utils";

const AddTitle = ({ titleId }) => {

    const onTitleSaved = (title, addAnother) => {
        let id = title.id.split("-")[1];
        if (!addAnother) {
            if (title.productType === 'Episode' || title.productType === 'Movie') {
                window.location.href = '/scheduler/titles/' + id;
            } else {
                window.location.href = '/scheduler/titles/';
            }
        }
    };

    return (
        <div>
            <TitleAddition 
                creationSource={creationSource}
                disableAddAlpha={true}
                titleSaved={onTitleSaved}
                axiosInstance={interceptor()}
                env={getEnv()}
            />
        </div>
    );
};

export default AddTitle;